// extracted by mini-css-extract-plugin
export default {"legendButton":"LegendButton_legendButton__ZGKFD","legendButtonWarning":"LegendButton_legendButtonWarning__AOnEs"};